// extracted by mini-css-extract-plugin
export default {"teamContainer":"Team_teamContainer__HRnlI","teamMembers":"Team_teamMembers__Bx0mY","member":"Team_member__5Z1R+"};